import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')

const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffCrudSellers = () => import('./staff/crudSellers')
const ViewStaffSellersCalendar = () => import('./staff/crudSellersCalendar')
const ViewStaffSellersReports = () => import('./staff/crudSellersReports')
const ViewStaffCrudZones = () => import('./staff/crudZones')
const ViewStaffListCalendar = () => import('./staff/listCalendarSellers')
const ViewStaffListCustomers = () => import('./staff/listCustomersSellers')
const ViewStaffListLocations = () => import('./staff/listLocationsSellers')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) ->
// nombre de ruta. Fuente única, ver router/viewsRegistry.js.
const VIEWS = {
  dashboard: 'SellersStaffDashboard',
  crudSellers: 'SellersStaffCrudSellers',
  crudSellersCalendar: 'SellersStaffSellersCalendar',
  crudSellersReports: 'SellersStaffSellersReports',
  crudZones: 'SellersStaffCrudZones',
  listCalendarSellers: 'SellersStaffListCalendar',
  listCustomersSellers: 'SellersStaffListCustomers',
  listLocationsSellers: 'SellersStaffListLocations',
}

const router =
  [
    {
      path: '/st/sellers',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: VIEWS.dashboard,
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Vendedores',
          }             
        },        
        {
          path: 'sellers',
          name: VIEWS.crudSellers,
          component: ViewStaffCrudSellers,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Gestión de vendedores',
          }                       
        }, 
        {
          path: 'sellers/:sellersID/calendar',
          name: VIEWS.crudSellersCalendar,
          component: ViewStaffSellersCalendar,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Calendario de vendedor',
          }                                 
        },     
        {
          path: 'sellers/:sellersID/reports',
          name: VIEWS.crudSellersReports,
          component: ViewStaffSellersReports,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Reportes de vendedores',
          }                                 
        },           
        {
          path: 'zones',
          name: VIEWS.crudZones,
          component: ViewStaffCrudZones,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Gestión de zonas',
          }                                 
        },  
        {
          path: 'my-calendar',
          name: VIEWS.listCalendarSellers,
          component: ViewStaffListCalendar,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Mi calendario',
          }                                 
        },
        {
          path: 'my-customers',
          name: VIEWS.listCustomersSellers,
          component: ViewStaffListCustomers,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Mis clientes',
          }                                 
        },
        {
          path: 'locations',
          name: VIEWS.listLocationsSellers,
          component: ViewStaffListLocations,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Recorrido de vendedores',
          }
        },                              
      ]
    },

    {
      path: '/cu/sellers',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/sellers',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
export { VIEWS }
